(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/views/tipsen/round.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/views/tipsen/round.js');
"use strict";


const {
  SportinfoPathNames
} = svs.components.sportinfo.common.constants;
svs.game_results.views.Round = Marionette.View.extend({
  log: new svs.core.log.Logger('svs.game_results.views.Round'),
  template(data) {
    return svs.game_results.templates.round(data);
  },
  className() {
    const className = 'js-expandable-box padding-xs-bottom-1';
    return className;
  },
  regions: {
    matchList: '#match-list',
    forecastPayment: '#forecast-payment'
  },
  events: {
    'click .js-expand-big-statistics': 'expandBigStatistics'
  },
  modelEvents: {
    'change:draw': 'render',
    'change:drawState': 'drawStateUpdated',
    'change:forecast': 'forecastChanged',
    'change:resultIdx': 'resultIdUpdated',
    'change:liveResults': 'liveResultsUpdated'
  },
  initialize() {
    this.bigStat = new svs.game_results.BigStat();
  },
  getBigStatOptions(e) {
    var _this$model$get, _this$model$get2;
    const cleanedUpPathname = Backbone.history.location.pathname.replace(new RegExp("/".concat(Object.values(SportinfoPathNames).join('|'), "$"), 'i'), '');
    const pathname = cleanedUpPathname;
    const matchId = e && parseInt(e.currentTarget.id.split('-')[1], 10);
    const bigStatOptions = {
      productId: (_this$model$get = this.model.get('draw')) === null || _this$model$get === void 0 ? void 0 : _this$model$get.productId,
      drawNumber: (_this$model$get2 = this.model.get('draw')) === null || _this$model$get2 === void 0 ? void 0 : _this$model$get2.drawNumber,
      matchId,
      searchParams: "match=".concat(matchId),
      queryKey: 'match',
      tab: svs.game_results.data.params.tab,
      domElement: svs.core.detect.formfactor.desktop() ? '#bigStatRegion' : '#bigstat-modal',
      modulePath: pathname
    };
    return bigStatOptions;
  },
  onRender() {
    if (this.model.get('draw')) {
      const liveResults = this.model.get('draw').drawEvents;
      this.matchList = new svs.game_results.collections.MatchList(liveResults, {
        modelFromView: this.model
      });
      this.showChildView('matchList', new svs.game_results.views.MatchList({
        collection: this.matchList
      }));
    }

    if (this.model.get('forecast') && (this.model.get('roundIsLive') || this.model.get('product') === 'bomben')) {
      this.forecastPayment = new svs.game_results.models.ForecastPayment({
        forecast: this.model.get('forecast'),
        product: this.model.get('product'),
        rowPrice: this.model.get('draw').rowPrice,
        isTrotting: this.model.get('isTrotting')
      });
      this.showChildView('forecastPayment', new svs.game_results.views.ForecastPayment({
        model: this.forecastPayment
      }));
    }
    if (this.model.get('draw')) {
      const bigStatOptions = this.getBigStatOptions();
      this.bigStat.navToBigStat(bigStatOptions);
    }
    svs.game_results.models.calendar.on('change:date', () => {
      const domElement = svs.core.detect.formfactor.desktop() ? '#bigStatRegion' : '#bigstat-modal';
      this.bigStat.closeBigStat(domElement);
      svs.game_results.data.params.tab = undefined;
    });
  },
  forecastChanged() {
    const forecast = this.model.get('forecast');
    if (forecast && this.forecastPayment) {
      this.forecastPayment.set('forecast', forecast);
      this.forecastPayment.set('winresult', forecast.winresult);
      this.forecastPayment.set('multiForecast', forecast.multiForecast);
    }
  },
  liveResultsUpdated() {
    const events = this.model.get('liveResults').drawEvents || this.model.get('liveResults').events;
    this.matchList.updateMatches(events);
  },
  drawStateUpdated() {
    const forecast = this.model.get('forecast');
    const drawState = forecast ? forecast.drawState : '';
    if (drawState && drawState == svs.game_results.constants.drawStates.FINALIZED) {
      this.model.set('roundIsLive', false, {
        silent: true
      });
    }
    this.render();
  },
  getChangeOnTeam(oldForecast, newForecast) {
    if (!oldForecast || !newForecast) {
      return '';
    }
    if (oldForecast.home !== newForecast.home) {
      return 'home';
    } else if (oldForecast.away !== newForecast.away) {
      return 'away';
    }
    return '';
  },
  getEventResultHasChanged(oldForecast, newForecast) {
    if (!oldForecast || !newForecast) {
      return false;
    }
    if (oldForecast.home !== newForecast.home) {
      return true;
    } else if (oldForecast.away !== newForecast.away) {
      return true;
    }
    return false;
  },
  resultIdUpdated() {
    const forecast = this.options.model.get('forecast');
    const changes = this.options.model.get('changes');

    if (this.options.model.get('product') === 'bomben' && !changes.length) {
      for (let i = 0; i < this.matchList.models.length; i++) {
        this.matchList.models[i].set('latestUpdate', this.getChangeOnTeam(this.matchList.models[i].get('forecastResult'), forecast.drawResults[i]), {
          silent: true
        });
        this.matchList.models[i].set('hasChangedResult', this.getEventResultHasChanged(this.matchList.models[i].get('forecastResult'), forecast.drawResults[i]), {
          silent: true
        });
        this.matchList.models[i].set('forecastResult', forecast.drawResults[i]);
        this.matchList.models[i].updateStatuses();
        this.matchList.models[i].trigger('matchUpdated', this.matchList.models[i]);
      }
    } else {
      let matchIndex = 0;
      for (let j = 0; j < changes.length; j++) {
        matchIndex = changes[j].evnum - 1;
        this.matchList.models[matchIndex].set('forecastResult', forecast.drawResults[matchIndex]);
        this.matchList.models[matchIndex].set('latestUpdate', changes[j].team, {
          silent: true
        });
        this.matchList.models[matchIndex].updateStatuses();
        this.matchList.models[matchIndex].trigger('matchUpdated', this.matchList.models[matchIndex]);
      }
    }
  },
  expandBigStatistics(e) {
    const bigStatOptions = this.getBigStatOptions(e);
    this.bigStat.openBigStat(bigStatOptions);
    this.bigStat.updateBigStatUrlQuery(bigStatOptions);
  }
});

 })(window);